import { useSelector } from 'react-redux';
import { catchErr } from '../../../../libs/HelperContent';
import { getIndustry, getRelationsData } from '../../../actions/feeds_actions_new';

const useGetRelIndData = () =>
{
	const session = useSelector((state:any) => state?.mysession?.session);
	const query = {
		uid     : session?.userId,
		comid   : session?.companyId,
		empRole : session?.empRole,
		role    : session?.role

	};
	const getFiltrData = async (setLoading, key) =>
	{
		try
		{
			setLoading(true);
			const queryParams = {
				...query,
				type      : 'feed',
				selection : true,
				skip      : 0,
				limit     : 20
			};
			const res = key === 'relations' ? await getRelationsData(queryParams) : await getIndustry(queryParams);

			if (res?.status)
			{
				return res?.data;
			}
			else
			{
				return {};
			}
		}
		catch (err)
		{
			catchErr(err);
		}
		finally
		{
			setLoading(false);
		}
	};

	return getFiltrData;
};

export default useGetRelIndData;